import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";
import { forwardRef } from "react";
import { cn } from "../../../lib";

const labelVariants = cva(
  "inline-flex items-center rounded-md px-2 py-1 text-sm font-medium ring-1 ring-inset ",
  {
    variants: {
      variant: {
        red: "bg-red-50 text-red-700 ring-red-600/20",
        green: "bg-green-50 text-green-700 ring-green-600/20",
        none: "bg-gray-50 text-gray-700 ring-gray-600/20",
      },
    },
    defaultVariants: {
      variant: "none",
    },
  },
);

interface TintedLabelProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof labelVariants> {
  label?: string;
}

const TintedLabel = forwardRef<HTMLDivElement, TintedLabelProps>(
  (props: TintedLabelProps, ref: React.Ref<HTMLDivElement>) => {
    const { className, variant = "none", label } = props;
    return (
      <div className="flex whitespace-nowrap h-auto" ref={ref}>
        <span className={cn(labelVariants({ variant }), className)}>
          {label}
        </span>
      </div>
    );
  },
);

export default TintedLabel;
export type { TintedLabelProps };
